import { AppConstants } from "./constants";

export class HTMLTags {
  static readonly HTML = "<html>";
  static readonly HTML_CLS = "</html>";
  static readonly TITLE = "<title>";
  static readonly TITLE_CLS = "</title>";
  static readonly BODY = "<body>";
  static readonly BODY_CLS = "</body>";
  static readonly HEAD = "<head>";
  static readonly HEAD_CLS = "</head>";
  static readonly THEAD = "<thead>";
  static readonly THEAD_CLS = "</thead>";
  static readonly TBODY = "<tbody>";
  static readonly TBODY_CLS = "</tbody>";
  static readonly TABLE = (border: number = 0) => `<table border='${border}'>`; // Allow dynamic attributes
  static readonly TABLE_CLS = "</table>";
  static readonly TR = "<tr>";
  static readonly TR_CLS = "</tr>";
  static readonly TH = (content: any) => `<th>${content}</th>`;
  static readonly TD = (content: any) => `<td>${content}</td>`;
  static readonly ANCHOR = "a";
  static readonly NEXT_LINE = "\n";
  static readonly BR = "<br>";
  static readonly P = (phrase: string | null) => `<p>${phrase ?? AppConstants.BLANK}</p>`;
}